import { Rainbow } from '@tencent/rainbow-browser-sdk';

interface IRainbow {
    getConfigByKey: (key: string, groupName: string) => Promise<any>;
    getConfigByGroup: (groupName: string) => Promise<any>;
}

const PROJECT_INFO = {
    appID: '209c666a-da38-4a97-9156-e50b4a5c3225',
    userID: '046074cbdb184f17b48f72b7b1c73398',
    secretKey: 'cc9ff3fdf26f73368cc23fad657bc3701b4d',
};

export default class RainbowManager implements IRainbow {
    private static instance: RainbowManager;
    public static getInstance(): RainbowManager {
        if (!this.instance) {
            this.instance = new RainbowManager();
        }
        return this.instance;
    }
    private rainbowIns;
    private retryCount: number;
    private constructor() {
        this.rainbowIns = new Rainbow({
            connectStr: 'https://oi.rb.qq.com',
        });
        this.retryCount = 0;
    }

    /**
     * 请求七彩石对应 key 配置
     * @param key 配置的key
     * @param groupName 配置所属的组
     * @returns 返回promise，promise的value为key对应的配置的值，如果出错则值为undefined
     */
    public async getConfigByKey(key: string, groupName?: string): Promise<any> {
        const group = groupName ?? this.getDefaultGroup();
        const result = await this.rainbowIns.get(key, {
            ...PROJECT_INFO,
            group,
        }).catch((err) => {
            window.log.error('rainbow error', err);
            return this.retry(this.getConfigByKey, key, groupName);
        });

        this.retryCount = 0;
        return result;
    }

    /**
     * 请求七彩石整组配置
     * @param groupName 配置所属的组
     * @returns 返回promise，promise的value为整组对应的配置的值，如果出错则值为undefined
     */
    public async getConfigByGroup(groupName?: string): Promise<any> {
        const group = groupName ?? this.getDefaultGroup();
        const result = await this.rainbowIns.getGroup({
            ...PROJECT_INFO,
            group,
        }).catch((err) => {
            window.log.error('rainbow error', err);
            return this.retry(this.getConfigByGroup, groupName);
        });

        this.retryCount = 0;
        return result;
    }

    /**
     * 配置拉取失败后，重试一次
     * @param func
     * @param args
     * @returns
     */
    private async retry(func, ...args): Promise<any> {
        if (this.retryCount > 0) return;
        this.retryCount += 1;
        const result = await func.apply(this, args);
        return result;
    }

    /**
     * 根据环境返回默认分组
     * @returns 返回七彩石平台设置的组名
     */
    private getDefaultGroup(): string {
        return __IS_PROD__ ? 'ENV.PROD' : 'ENV.DEV';
    }
}
